

import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Modal, Card } from 'react-bootstrap'
import axios from 'axios'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const Broker = ({ onBrokerCreated }) => {
  const [broker, setBroker] = useState({
    name: '',
    father_name: '',
    pancard_number: '',
    email: '',
    phone_number: '',
    id_number: '',
    city: '',
    state: '',
    pincode: '',
    account_number: '',
    ifsc_code: '',
    bank_name: '',
    account_holder_name: '',
    address: '',
    refer_by: '',
    id_type: '',
    broker_level: '',
  })

  const [brokers, setBrokers] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const validIdTypes = ['AADHAR CARD', 'PAN CARD', 'LICENSE']
  const validLevels = [
    'LEVEL1', 'LEVEL2', 'LEVEL3', 'LEVEL4', 'LEVEL5', 'LEVEL6',
    'LEVEL7', 'LEVEL8', 'LEVEL9', 'LEVEL10', 'LEVEL11', 'LEVEL12', 'LEVEL13'
  ]

  const navigate = useNavigate()
  const token = Cookies.get('authToken')

  useEffect(() => {
    if (!token) {
      window.location.href = '/login'
    }
  }, [token])

  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  useEffect(() => {
    const fetchBrokers = async () => {
      try {
        const response = await axiosInstance.get('/brokers/search')
        setBrokers(response.data.data)
      } catch (error) {
        toast.error('Failed to fetch brokers')
      }
    }
    fetchBrokers()
  }, [])

  const handleBrokerSelect = (e) => {
    setBroker({ ...broker, refer_by: e.target.value })
  }

  const inputHandler = (e) => {
    const { name, value } = e.target
    setBroker({ ...broker, [name]: value })
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    if (!broker.broker_level || broker.broker_level === 'SELECT') {
      toast.error('Please select an associate level.')
      setLoading(false)
      return
    }

    if (!broker.id_type || !validIdTypes.includes(broker.id_type)) {
      toast.error('Please select a valid ID type.')
      setLoading(false)
      return
    }

    if (!validLevels.includes(broker.broker_level)) {
      toast.error('Invalid Associate Level selected.')
      setLoading(false)
      return
    }

    try {
      const response = await axiosInstance.post('/broker/create', broker)
      toast.success('Associate created successfully!')
      setShowModal(true)
      setTimeout(() => {
        navigate('/allassociate')
        window.location.reload()
      }, 3000)
    } catch (err) {
      toast.error(err.response?.data.message || 'Failed to create associate.')
    } finally {
      setLoading(false)
    }
  }

  const handleModalClose = () => setShowModal(false)

  return (
  <Container className="pb-3" style={{fontFamily: theme.font.family }}>


        <Form onSubmit={submitForm}   className="border-0 rounded-3 p-3" style={{ backgroundColor: theme.colors.background }}>

        <p
          className="mb-4 fw-bold"
          style={{
            color: theme.colors.primary,
            borderBottom: `2px solid ${theme.colors.secondary}`,
            paddingBottom: '8px',
            
            fontSize: '1.5rem',
          }}
        >
          Create New Associate        
        </p>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={broker.name}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Father's Name *</Form.Label>
              <Form.Control
                type="text"
                name="father_name"
                value={broker.father_name}
                onChange={inputHandler}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Phone Number *</Form.Label>
              <Form.Control
                type="tel"
                name="phone_number"
                value={broker.phone_number}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Email *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={broker.email}
                onChange={inputHandler}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col md={12} className="mb-3">
              <Form.Label className="fw-medium">Associate Level *</Form.Label>
              <Form.Select
                name="broker_level"
                value={broker.broker_level}
                onChange={inputHandler}
                required
              >
                <option value="">SELECT</option>
                {validLevels.map((lvl, i) => (
                  <option key={lvl} value={lvl}>
                    {lvl.replace('LEVEL', 'LEVEL ')} - {i + 4}%
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          <Row>
            <Col md={4} className="mb-3">
              <Form.Label className="fw-medium">State *</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={broker.state}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={4} className="mb-3">
              <Form.Label className="fw-medium">City *</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={broker.city}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={4} className="mb-3">
              <Form.Label className="fw-medium">Pincode *</Form.Label>
              <Form.Control
                type="text"
                name="pincode"
                value={broker.pincode}
                onChange={inputHandler}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Account Number *</Form.Label>
              <Form.Control
                type="text"
                name="account_number"
                value={broker.account_number}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">IFSC Code *</Form.Label>
              <Form.Control
                type="text"
                name="ifsc_code"
                value={broker.ifsc_code}
                onChange={inputHandler}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Bank Name *</Form.Label>
              <Form.Control
                type="text"
                name="bank_name"
                value={broker.bank_name}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Account Holder's Name *</Form.Label>
              <Form.Control
                type="text"
                name="account_holder_name"
                value={broker.account_holder_name}
                onChange={inputHandler}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col md={12} className="mb-3">
              <Form.Label className="fw-medium">Address *</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={broker.address}
                onChange={inputHandler}
                rows={2}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">Refer By *</Form.Label>
              <Form.Select
                name="refer_by"
                value={broker.refer_by}
                onChange={handleBrokerSelect}
                required
              >
                <option value="">SELECT</option>
                {brokers.map((b) => (
                  <option key={b.broker_id ?? b.id} value={b.broker_id ?? b.id}>
                    {b.broker_id}_{b.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">ID Type *</Form.Label>
              <Form.Select
                name="id_type"
                value={broker.id_type}
                onChange={inputHandler}
                required
              >
                <option value="">SELECT</option>
                <option value="AADHAR CARD">AADHAR CARD</option>
                <option value="PAN CARD">PAN CARD</option>
                <option value="LICENSE">DRIVING LICENSE</option>
              </Form.Select>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">ID Number *</Form.Label>
              <Form.Control
                type="text"
                name="id_number"
                value={broker.id_number}
                onChange={inputHandler}
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-medium">PAN Card Number *</Form.Label>
              <Form.Control
                type="text"
                name="pancard_number"
                value={broker.pancard_number}
                onChange={inputHandler}
                required
              />
            </Col>
          </Row>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="d-grid mt-4">
            <Button
              type="submit"
              className="fw-semibold py-2"
              style={{
                backgroundColor: theme.colors.primary,
                border: 'none',
                fontSize: '1.05rem',
              }}
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create New Associate'}
            </Button>
          </div>
        </Form>
    

      {/* Success Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-semibold" style={{ color: theme.colors.primary }}>
            Welcome, New Associate!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-0">
            The new associate has been successfully created. You can now manage or view their details.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            style={{
              backgroundColor: '#8E9B56',
              color: '#fff',
              border: 'none',
              fontWeight: 600,
              // minWidth: '100px',
            }}
            onClick={handleModalClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Broker
